module.exports = __webpack_public_path__ + "img/pink.dff5c952.svg";